import store from "@/store/store";

export default async (to, from, next) => {
  if (store.state.order.order.length) {
    return next();
  }

  return next("/");
};
